import api from "api";
import { put, select, takeLatest } from "redux-saga/effects";

import { resources, resourceTypes } from "../actions";
import {
  FETCH_RESOURCE_TYPES_START,
  FETCH_RESOURCES_START,
  FETCH_RESOURCES_SUCCESS} from "../constants";
import selectors from "../selectors";
import { fetchPagedSagaFactory } from "./utils";

export const resourcesSaga = fetchPagedSagaFactory(
  api.Resources.get,
  resources.success,
  resources.failed
);

export const resourceTypesSaga = fetchPagedSagaFactory(
  api.ResourceTypes.get,
  resourceTypes.success,
  resourceTypes.failed
);

export function* preselectResourceSaga() {
  const serviceResources = yield select(
    selectors.resources.getByCurrentService
  );
  if (serviceResources.length) {
    yield put(resources.setCurrent(serviceResources[0].$uri));
  }
}

export function* watchResources() {
  yield takeLatest(FETCH_RESOURCES_START, resourcesSaga);
}

export function* watchPreselectResource() {
  yield takeLatest(FETCH_RESOURCES_SUCCESS, preselectResourceSaga);
}

export function* watchResourceTypes() {
  yield takeLatest(FETCH_RESOURCE_TYPES_START, resourceTypesSaga);
}
